import { combineReducers } from 'redux';
import { signInFormReducer } from '@zocdoc-frontend-common/components-sign-in-form';
import { userReducer } from '@zocdoc-frontend-common/state-user-account/reducers/userReducer';

export const headerReducers = {
    user: userReducer,
    signInForm: signInFormReducer,
};

export const headerReducer = combineReducers(headerReducers);
